<template>
  <div></div>
</template>
<script>
import axios from 'axios'
// 前端访问后端的callback地址(不配置的话默认是:{后端域名}/callback)以获取access-token（即ssoid）
export default {
  created () {

  }
}
</script>
